/**
 * Implement Gatsby's Browser APIs in this file.
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

import { initializeConsent } from './src/utils/cookies';
import { initializeAnalytics, trackPageView } from './src/utils/analytics';

// Initialize cookie consent when the client-side app starts
export const onClientEntry = () => {
  // Check if we're on production and running on a non-standard port
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    const port = window.location.port;

    // Log warning if production site is running on non-standard port
    if ((hostname === 'sysbioz.com' || hostname === 'www.sysbioz.com') && port && port !== '80' && port !== '443') {
      console.warn(`Warning: Production site is running on port ${port}. This may cause URL generation issues.`);
      console.warn('Consider configuring a reverse proxy to serve the site on standard ports (80/443).');
    }
  }

  // Initialize consent state before any scripts load
  initializeConsent();

  // Initialize analytics based on consent (will only load if user consented)
  setTimeout(() => {
    initializeAnalytics();
  }, 100);
};

// Track page views and re-check consent on route changes
export const onRouteUpdate = ({ location, prevLocation }) => {
  // Re-check consent preferences on route change
  initializeConsent();

  // Track page view if analytics is enabled
  if (location && prevLocation) {
    trackPageView(location.pathname + location.search);
  }
};